import $ from 'jquery';
import React from 'react';
import { COMPANION_DESCRIPTION, COMPANION_TITLE } from '../../constants/Labels';
import { validateField } from '../../helpers/tools';
import { initStateObj } from '../../constants/Constants';

class Companion extends React.Component {
  timeout = null;
  constructor(props) {
    super(props);
    globalThis.addEventListener('resize', this.updatePlayerSize.bind(this));
    this.state = {
      playerWidth: 0,
    };
  }
  componentDidMount() {
    this.updatePlayerSize();
    this.toggleBlurListeners(true);
  }
  componentDidUpdate() {
    this.toggleBlurListeners(false);
    this.toggleBlurListeners(true);
  }
  updatePlayerSize = () => {
    this.setState({
      playerWidth: this.getPlayerSize(),
    });
  };
  getPlayerSize = () => {
    const playerElement = document.getElementsByClassName('playerSelectionPanel');
    return playerElement.item(0).clientWidth;
  };

  updateState = () => {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    const companionData = {
      isValid: true,
      width: $('input[name=companionWidth]').val(),
      height: $('input[name=companionHeight]').val(),
    };
    const items = $('.companionArea .validationError').toArray();
    for (const item of items) {
      if ($(item).is(':visible')) {
        companionData.isValid = false;
        break;
      }
    }
    if (companionData.isValid) {
      this.props.updateState(companionData);
    }
  };
  handleChange = event => {
    const maxSize = event.target.name === 'companionWidth' ? this.state.playerWidth : 1200;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      if (event.target.value == '') {
        event.target.value =
          event.target.name === 'companionWidth'
            ? initStateObj.companionWidth
            : initStateObj.companionHeight;
      }
      validateField(event, 'integer', true, this.updateState, 1, maxSize);
    }, 1500);
  };
  toggleBlurListeners = addListeners => {
    if (addListeners) {
      $('input[name="companionWidth"]').on('blur', event => {
        if (event.target.value === '') {
          $('input[name=companionWidth]').val(initStateObj.companionWidth);
        }
        validateField(event, 'integer', true, this.updateState, 1, this.state.playerWidth);
      });
      $('input[name="companionHeight"]').on('blur', event => {
        if (event.target.value === '') {
          $('input[name=companionHeight]').val(initStateObj.companionHeight);
        }
        validateField(event, 'integer', true, this.updateState, 1, 1200);
      });
    } else {
      $('input[name="companionWidth"]').off('blur');
      $('input[name="companionHeight"]').off('blur');
    }
  };

  render() {
    return (
      <div className="companionArea">
        <div className="companionAreaTitle">{COMPANION_TITLE}</div>
        <div>
          <label>{COMPANION_DESCRIPTION}</label>
        </div>
        <table>
          <tbody>
            <tr>
              <td>
                <label>Width</label>
              </td>
              <td style={{ width: '10%' }}></td>
              <td>
                <label>Height</label>
              </td>
            </tr>
            <tr>
              <td>
                <div className="smallInput">
                  <input
                    type="number"
                    name="companionWidth"
                    className="textFiled"
                    defaultValue={this.props.companionWidth}
                    key={this.props.companionWidth}
                    onChange={this.handleChange}
                  />
                  <div className="validationError"></div>
                </div>
              </td>
              <td style={{ textAlign: 'center', width: '10%' }}>
                <label className="xlabel">x</label>
              </td>
              <td>
                <div className="smallInput">
                  <input
                    type="number"
                    name="companionHeight"
                    className="textFiled"
                    defaultValue={this.props.companionHeight}
                    key={this.props.companionHeight}
                    onChange={this.handleChange}
                  />
                  <div className="validationError"></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div id="companionContent">
          {(() => {
            const marginLeft =
              this.state.playerWidth - this.props.companionWidth < 20
                ? Math.floor((this.state.playerWidth - this.props.companionWidth) / 2)
                : 10;
            return (
              <div
                id="testCompanion"
                style={{
                  width: this.props.companionWidth + 'px',
                  height: this.props.companionHeight + 'px',
                  maxWidth: this.state.playerWidth - marginLeft + 'px',
                  maxHeight: '1200px',
                  marginLeft: marginLeft + 'px',
                }}
              >
                <div id="testCompanionHeader">
                  {this.props.companionWidth} x {this.props.companionHeight} <br />
                  slot id = &quot;testCompanion&quot;
                </div>
              </div>
            );
          })()}
        </div>
      </div>
    );
  }
}

export default Companion;
